import { render, staticRenderFns } from "./ProductConfigurationManagement.vue?vue&type=template&id=6694834a&scoped=true"
import script from "./ProductConfigurationManagement.vue?vue&type=script&lang=js"
export * from "./ProductConfigurationManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductConfigurationManagement.vue?vue&type=style&index=0&id=6694834a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6694834a",
  null
  
)

export default component.exports